/* 
    You can use this class to extract pure paragraphs from a node.
    For example, when this is the node you pass in as container:
    <div>
        <div>
            <p>Hello</p>
        </div>
        <p>Hello again</p>
    </div>

    You'll get a NodeList with those results:

    <p>Hello</p>
    <p>Hello again</p>
*/
export default class PureParagraphs {
    
    constructor(container) {
        this.container = container;
        this.paragraphs = [];
        this.extractFromNode(container);
    }

    extractFromNode(node) {
        node.childNodes.forEach(childNode => {
            if (childNode.nodeType === Node.ELEMENT_NODE) {
                if (childNode.tagName === 'P') {
                    this.paragraphs.push(childNode);
                }
                this.extractFromNode(childNode);
            }
        });
    }
}